import { hasThumb } from '@/components/core/visual';
import type { Visual } from '@/types/visual';

/**
 * The card a deck's thumbnail shows: its first card, with the deck's first
 * picture as the poster. The concept's picture sits on the first card after
 * the cover (covers are typographic), so a tile showing only the cover would
 * never show it.
 */
export function posterCard<T extends { visual?: Visual | null }>(
  cards: T[]
): T | undefined {
  const first = cards[0];
  if (!first || hasThumb(first.visual)) return first;
  const picture = cards.find(c => hasThumb(c.visual))?.visual;
  return picture ? { ...first, visual: picture } : first;
}
